import { TRecommendation } from '../../types/recommendation';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { EPaginationStatus } from '../../types/redux/recommendations';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export type TSetRecommendationsPayload = Array<TRecommendation>;
export type TAppendRecommendationsPayload = {
  recommendations: TRecommendation[];
  hasMore: boolean;
  page: number;
  totalCount: number | null;
};
export type TSetRecommendationsPaginationStatusPayload = EPaginationStatus;
export type TToggleFavoritePayload = {
  offerId: number;
  isFavorite: boolean;
};
export type TFavoriteUpdatePayload = TToggleFavoritePayload & {
  requestId: string;
};
export type TFinishFavoriteUpdatePayload = Pick<TFavoriteUpdatePayload, 'offerId' | 'requestId'>;

export enum ERecommendationsActionTypes {
  AppendRecommendations = 'RECOMMENDATIONS / APPEND_RECOMMENDATIONS',
  FinishFavoriteUpdate = 'RECOMMENDATIONS / FINISH_FAVORITE_UPDATE',
  RollbackFavoriteUpdate = 'RECOMMENDATIONS / ROLLBACK_FAVORITE_UPDATE',
  SetRecommendations = 'RECOMMENDATIONS / SET_RECOMMENDATIONS',
  SetRecommendationsPaginationStatus = 'RECOMMENDATIONS / SET_RECOMMENDATIONS_PAGINATION_STATUS',
  StartFavoriteUpdate = 'RECOMMENDATIONS / START_FAVORITE_UPDATE',
  ToggleFavorite = 'RECOMMENDATIONS / TOGGLE_FAVORITE',
}

export type TRecommendationsActions =
  | ITypedReduxAction<ERecommendationsActionTypes.AppendRecommendations, TAppendRecommendationsPayload>
  | ITypedReduxAction<ERecommendationsActionTypes.FinishFavoriteUpdate, TFinishFavoriteUpdatePayload>
  | ITypedReduxAction<ERecommendationsActionTypes.RollbackFavoriteUpdate, TFavoriteUpdatePayload>
  | ITypedReduxAction<ERecommendationsActionTypes.SetRecommendations, TSetRecommendationsPayload>
  | ITypedReduxAction<
      ERecommendationsActionTypes.SetRecommendationsPaginationStatus,
      TSetRecommendationsPaginationStatusPayload
    >
  | ITypedReduxAction<ERecommendationsActionTypes.StartFavoriteUpdate, TFavoriteUpdatePayload>
  | ITypedReduxAction<ERecommendationsActionTypes.ToggleFavorite, TToggleFavoritePayload>;

export const appendRecommendations: (payload: TAppendRecommendationsPayload) => TRecommendationsActions =
  actionGenerator<ERecommendationsActionTypes.AppendRecommendations, TAppendRecommendationsPayload>(
    ERecommendationsActionTypes.AppendRecommendations,
  );

export const finishFavoriteUpdate: (payload: TFinishFavoriteUpdatePayload) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.FinishFavoriteUpdate,
  TFinishFavoriteUpdatePayload
>(ERecommendationsActionTypes.FinishFavoriteUpdate);

export const rollbackFavoriteUpdate: (payload: TFavoriteUpdatePayload) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.RollbackFavoriteUpdate,
  TFavoriteUpdatePayload
>(ERecommendationsActionTypes.RollbackFavoriteUpdate);

export const setRecommendations: (payload: TSetRecommendationsPayload) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.SetRecommendations,
  TSetRecommendationsPayload
>(ERecommendationsActionTypes.SetRecommendations);

export const setRecommendationsPaginationStatus: (
  payload: TSetRecommendationsPaginationStatusPayload,
) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.SetRecommendationsPaginationStatus,
  TSetRecommendationsPaginationStatusPayload
>(ERecommendationsActionTypes.SetRecommendationsPaginationStatus);

export const startFavoriteUpdate: (payload: TFavoriteUpdatePayload) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.StartFavoriteUpdate,
  TFavoriteUpdatePayload
>(ERecommendationsActionTypes.StartFavoriteUpdate);

export const toggleFavorite: (payload: TToggleFavoritePayload) => TRecommendationsActions = actionGenerator<
  ERecommendationsActionTypes.ToggleFavorite,
  TToggleFavoritePayload
>(ERecommendationsActionTypes.ToggleFavorite);
